/**
 * Validate fields for containing valid phone number (and not empty)
 * Will accept various phone number formats, but input is coerced into (###) ###-#### format
 *
 * @param {string} input - the value of the fields being validated
 * @return {boolean} isValid - does the input value pass the test
 */
function telValidator(input) {
  const regexpTest = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

  const isValid = input.length > 0 && regexpTest.test(input);

  return isValid;
}

export default telValidator;



// WEBPACK FOOTER //
// ./scripts/util/validation/telValidator.js